export const redirectToLogout = (): void => {
  if (typeof window === "undefined") return;

  const path = window.location.pathname;
  if (path.includes("/logout") || path.includes("/sign-out")) return;

  window.location.href = "/rio/logout";
};
